


















import Vue from 'vue';
import { getQueryVariable } from '../../common/common';
import {
  mapState,
  mapActions
} from 'vuex';
import store from '../../store/index';

// // 模板文件不引入echarts
// import config from '../config/index';
// let echarts: any;
// if (config.env !== 'template') {
//   echarts = require('echarts');
//   require('echarts-liquidfill');
// }

export default Vue.extend({
  name: 'CheckInfo',
  computed: mapState({
    checkInfo: (state: any) => store.getters.getCheckInfo,
    productId: (state: any) => store.getters.getProductId
  }),
  watch: {

  },
  data() {
    return {
    };
  },
  methods: {
    toPercentageF(val: number) {
      return val.toFixed(4);
    },
    // 获取ProductId reportId
    getProductId() {
      this.$store.dispatch('setProductId', getQueryVariable('productId'));
      this.$store.dispatch('setReportId', getQueryVariable('reportId'));
    }
  },
  created() {
    this.getProductId();
  },
  mounted() {
  }
});
